<template>
  <v-menu offset-y v-if="!$root.isAuthenticated">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-account-box-outline</v-icon>
      </v-btn>
    </template>
    <v-list dense min-width="220">
      <v-subheader class="pl-4 subtitle-2 font-weight-light black--text">Добро пожаловать</v-subheader>
      <v-list-item-group v-model="current" color="primary">
        <v-list-item v-for="(item, index) in items" :key="index" :to="item.link">
          <v-list-item-icon class="mr-3">
            <v-icon v-text="item.icon"/>
          </v-list-item-icon>
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
        <v-list-item @click.prevent="logoutAction">
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Выйти</v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script type="text/javascript">
  import api from '@/api'

  export default {
    data: () => ({
      current: false,
      items: [
        { title: 'Профиль', icon: 'mdi-account', link: '/account/profile' },
//        { title: 'Выйти', icon: 'mdi-logout', link: '/account/logout' }
      ],
    }),
    methods: {
      logoutAction () {
        api.get('account/logout').then(response => {
          if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          self.location.reload()
      }).catch(error => {
        this.$root.$alert(error, true)
      })
      }
    }
  }
</script>
